import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export var replace = normalize.replace(function (options) {
  var _ref = options || {},
    url = _ref.url,
    _success = _ref.success,
    _fail = _ref.fail,
    _complete = _ref.complete;
  tt.redirectTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BYTE);
export default replace;